import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import http from "../api/server.js";
import { BOOKING_MANAGEMENT_AUDIT_HIS } from "../api/apiPath.js";
import Header from "./Header";
import SidebarIcons from "./SidebarIcons";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import dayjs from "dayjs";

import useGetClientId from "../hooks/useGetClientId";
const ResidentLog = () => {
  const { userObj } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const { state } = useLocation();
  const selectedRow = state?.selectedRow;

  const [timelineData, setTimelineData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hideSidebar, setHideSidebar] = useState(false);

  const clientObj = useGetClientId();
  const clientId = clientObj?.clientId;
  const buildTimeline = (apiData = []) => {
    if (!apiData.length) return [];

    return apiData
      .map((item) => {
        let title = item.status;

        if (item.status === "LinkSent") title = "Booking Email Sent";
        if (item.status === "Acknowledged") title = "Acknowledged";
        if (item.status === "LinkOpened") title = "Booking Link Opened";
        // if (item.status === "ReminderSent") title = "Reminder Sent";
        if (item.status === "Reminder") title = "Reminder Email Sent";

        if (item.status === "ManualFollowUp") title = "Manual Follow-up";
        // if (item.status === "BookingConfirmed") title = "Booking Confirmed";

        // let byName = item.isAcknowledged ? item.acknowledgedBy : item.createdBy;
        let byName = null;

        if (
          item.status === "Acknowledged" ||
          item.status === "Booking Link Accessed"
        ) {
          byName = item.acknowledgedBy;
        } else {
          byName = item.createdBy;
        }

        return {
          title,
          date:
            item.lastInteractionOn ||
            item.emailSentOn ||
            item.acknowledgedOn ||
            item.linkOpenedOn ||
            item.reminderSentOn ||
            item.manualFollowUpOn,
          // by: item.acknowledgedBy || item.createdBy || item.recipientEmail,
          // by: byName || item.recipientEmail || "-",
          by: byName,
          comment: item.manualFollowUpComment ?? null,
          manualFollowUpType: item.manualFollowUpType ?? null,
          manualFollowUpOutcome: item.manualFollowUpOutcome ?? null,
          show: true,
        };
      })
      .sort((a, b) => new Date(a.date) - new Date(b.date));
  };
  useEffect(() => {
    if (
      !clientId ||
      !selectedRow?.email ||
      !selectedRow?.trackingReferenceNumber
    ) {
      return;
    }

    const fetchAuditHistory = async () => {
      setLoading(true);
      try {
        const response = await http.get(BOOKING_MANAGEMENT_AUDIT_HIS, {
          params: {
            clientId: String(clientId),
            recipientEmail: selectedRow.email,
            refNumber: selectedRow.trackingReferenceNumber,
          },
        });

        setTimelineData(buildTimeline(response.data || []));
      } catch (error) {
        console.error("Error fetching audit history:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAuditHistory();
  }, [clientId, selectedRow?.email, selectedRow?.trackingReferenceNumber]);
  // const formatDateTime = (date) => {
  //   if (!date) return "-";

  //   const d = new Date(date);

  //   const day = String(d.getDate()).padStart(2, "0");
  //   const month = String(d.getMonth() + 1).padStart(2, "0");
  //   const year = d.getFullYear();

  //   let hours = d.getHours();
  //   const minutes = String(d.getMinutes()).padStart(2, "0");

  //   const ampm = hours >= 12 ? "PM" : "AM";

  //   hours = hours % 12;
  //   hours = hours ? hours : 12;
  //   hours = String(hours).padStart(2, "0");

  //   return `${day}/${month}/${year}, ${hours}:${minutes} ${ampm}`;
  // };

  const formatDateTime = (date) => {
    if (!date) return "-";

    return dayjs(date).format("DD-MMM-YYYY hh:mm A").toUpperCase();
  };
  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />

      {userObj && (
        <div className="dashboard_body_main">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}

          <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
            <div className="dashboard_header">
              <h2 className="mb-0">Resident Log</h2>
              <p className="header-description">View resident activity logs</p>
            </div>

            <div className="resident-card mb-3">
              <h5 className="text-start fw-semibold">Resident Log Timeline</h5>

              <div className="timeline">
                {loading && <p>Loading timeline...</p>}

                {!loading && timelineData.length === 0 && (
                  <p className="text-muted">No activity found</p>
                )}

                {timelineData.map((item, index) => (
                  <div className="timeline-item-row" key={index}>
                    <div className="timeline-left">
                      <div className="timeline-icon">
                        <div className="exact-check-icon">
                          <i className="fa-solid fa-check"></i>
                        </div>
                      </div>
                    </div>

                    <div
                      className="inspection-box text-start p-3"
                      style={{
                        backgroundColor: "#F9F9F9",
                        border: "1px solid #E5E5E5",
                      }}
                    >
                      <div className="timeline-info">
                        <div className="inspection-title-after">
                          {item.title} <span> by - {item.by}</span>
                        </div>

                        {item.show ? (
                          <>
                            <div className="inspection-date text">
                              {formatDateTime(item.date)}
                            </div>

                            {item.manualFollowUpType != null &&
                              item.manualFollowUpType !== "" && (
                                <div className="text-muted mt-1">
                                  {/* <strong>Type:</strong> {item.manualFollowUpType}   */}
                                  <strong>Type: </strong>{" "}
                                  {item.manualFollowUpType
                                    ?.replaceAll("_", " ")
                                    ?.replace(/\b\w/g, (char) =>
                                      char.toUpperCase(),
                                    )}
                                </div>
                              )}

                            {item.manualFollowUpOutcome != null &&
                              item.manualFollowUpOutcome !== "" && (
                                <div className="text-muted mt-1">
                                  <strong>Outcome: </strong>

                                  {item.manualFollowUpOutcome
                                    ?.replaceAll("_", " ")
                                    ?.replace(/\b\w/g, (char) =>
                                      char.toUpperCase(),
                                    )}
                                </div>
                              )}

                            {item.comment && (
                              <div className="text-muted mt-1">
                                <strong>Comment: </strong>
                                {item.comment
                                  ?.replaceAll("_", " ")
                                  ?.replace(/\b\w/g, (char) =>
                                    char.toUpperCase(),
                                  )}
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="text-muted">Not yet</div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="button-container text-end">
              <button
                type="button"
                className="btn-secondary col-sm-5 col-md-2"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};

export default ResidentLog;
